import { render } from "./IniciarSesion.vue?vue&type=template&id=5dbd8dc3&scoped=true"
import script from "./IniciarSesion.vue?vue&type=script&lang=js"
export * from "./IniciarSesion.vue?vue&type=script&lang=js"

import "./IniciarSesion.vue?vue&type=style&index=0&id=5dbd8dc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbd8dc3"]])

export default __exports__